import { render } from "./WebFooter.vue?vue&type=template&id=1c6050c0&scoped=true"
import script from "./WebFooter.vue?vue&type=script&lang=js"
export * from "./WebFooter.vue?vue&type=script&lang=js"

import "./WebFooter.vue?vue&type=style&index=0&id=1c6050c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6050c0"]])

export default __exports__